import { render, staticRenderFns } from "./GiftTangoCard.vue?vue&type=template&id=02b263bc&"
import script from "./GiftTangoCard.vue?vue&type=script&lang=js&"
export * from "./GiftTangoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports